import React from 'react';
import { Instant } from '../utility/datetime';
export const FREQUENCY_MILLISECONDS = (n) => n;
export const FREQUENCY_SECONDS = (n) => FREQUENCY_MILLISECONDS(n * 1000);
export const FREQUENCY_MINUTES = (n) => FREQUENCY_SECONDS(n * 60);
export const FREQUENCY_HOURS = (n) => FREQUENCY_MINUTES(n * 60);
export const useNow = (frequency = FREQUENCY_MILLISECONDS(250)) => {
    const [stateNow, setNow] = React.useState(Instant.now());
    React.useEffect(() => {
        const interval = window.setInterval(() => setNow(Instant.now()), frequency);
        return () => window.clearInterval(interval);
    });
    return stateNow;
};
export default useNow;
